import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import {
  DocToken,
  DocumentService,
} from "./services/document/document.service";

@Injectable({ providedIn: "root" })
export class DocTokenResolver implements Resolve<DocToken> {
  constructor(private service: DocumentService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<DocToken> | Promise<DocToken> | DocToken {
    return this.service.getToken();
  }
}
